import { Flex, FloraTypography } from '@grupoboticario/flora-react';
import { Link } from 'react-router-dom';
import { app } from 'core';
import { Container } from 'ui/components';
import ProductsCarousel from '../Showcases/ProductsCarousel/ProductsCarousel';
import { ButtonShowAll } from '../primitives/Heading/Heading.styles';

type TProductShowcase = {
  data: any;
  tagName: string;
  name: string;
  showcaseIndex: number;
};

const ProductShowcase = ({ data, tagName, name, showcaseIndex }: TProductShowcase) => {
  const isMobile = app.hooks.useApp('isMobile');

  return (
    <div key={`${tagName}-${showcaseIndex}`}>
      <Container fluid marginTop="sp-10" marginBottom="sp-4">
        <Flex>
          <FloraTypography
            fontSize="subtitle"
            as="h6"
            css={{ fontWeight: 400, color: '$medium-light-1', margin: 0 }}
            viewport={isMobile ? 'mobile' : 'desktop'}
          >
            {name}
          </FloraTypography>
          <Link to={`/vitrines?tag=${tagName}`}>
            <ButtonShowAll>Ver tudo</ButtonShowAll>
          </Link>
        </Flex>
      </Container>
      <Container fluid marginTop="sp-2">
        <ProductsCarousel isMobile={isMobile} data={data} />
      </Container>
    </div>
  );
};

export default ProductShowcase;
